import {action} from 'utils/redux';
import namespace from './namespace';
import {P, PaginatedData} from 'utils/types';

const creator = action(namespace);

export const initialize = creator('initialize');

export const destroy = creator('destroy');

export const changePage = creator('changePage', P.Number);

export const searchBuildings = creator('searchBuildings', P.Object);

export const recheckQuery = creator('recheckQuery');

export const openAreasSelector = creator('openAreasSelector');

export const closeAreasSelector = creator('closeAreasSelector');

export const setAreasSelectorType = creator('setAreasSelectorType', P.String);

export const setAreasSelectorSearch = creator('setAreasSelectorSearch', P.String);

export const openAreasSelectorSuggestion = creator(
	'openAreasSelectorSuggestion',
	P.String,
);

export const setActiveCallCampaign = creator('setActiveCallCampaign', P.Number);

export const createCallCampaign = creator('createCallCampaign');

export const updateCallCampaign = creator('updateCallCampaign');

export const removeCallCampaign = creator('removeCallCampaign');

export const openCallCampaignCreator = creator('openCallCampaignCreator');

export const closeCallCampaignCreator = creator('closeCallCampaignCreator');

export const navigateToBuilding = creator('navigateToBuilding', P.Number);

export const updateBuilding = creator('updateBuilding', P.Number);

export const _setBuildings = creator('_setBuildings', PaginatedData(P.Array));

export const _updateBuildingsQuery = creator('_updateBuildingsQuery', P.Object);

export const _setCallCampaigns = creator('_setCallCampaigns', P.Array);

export const _setActiveCallCampaign = creator('_setActiveCallCampaign', P.Object);

export const _clearActiveCallCampaign = creator('_clearActiveCallCampaign');

export const _createCallCampaign = creator('_createCallCampaign', P.Object);

export const _removeCallCampaign = creator('_removeCallCampaign', P.Number);

export const _updateCallCampaign = creator('_updateCallCampaign', P.Object);

export const _updateBuilding = creator('_updateBuilding', P.Object);

export const _opOk = creator('_opOk');

export const _opFailed = creator('_opFailed');
